{
  "markread": "Markera som läst",
  "newest": "Nyast",
  "unread": "Oläst",
  "starred": "Stjärnmärkt",
  "tags": "Taggar",
  "alltags": "Alla taggar",
  "timestamp": "{0,date} {0,time}",
  "hours": "för {0,plural,one {1 timme},other {# timmar}} sedan",
  "minutes": "för {0,plural,one {1 minut},other {# minuter}} sedan",
  "seconds": "för {0,plural,one {1 sekund},other {# sekunder}} sedan",
  "days": "{0,plural,zero {idag},one {igår},other {för # dagar sedan}}",
  "star": "stjärna",
  "unstar": "utan stjärna",
  "mark": "markera som läst",
  "unmark": "markera som oläst",
  "load_img": "bilder",
  "open_window": "öppna",
  "searchbutton": "sök",
  "sources": "Källa",
  "source_add": "Lägg till källa",
  "source_opml": "eller importera från opml-fil eller Google Reader",
  "source_edit": "redigera",
  "source_delete": "ta bort",
  "source_warn": "Vill du verkligen ta bort denna källa?",
  "source_new": "ny källa",
  "source_title": "Titel",
  "source_tags": "Tagg",
  "source_comma": "kommaseparerad",
  "source_select": "välj källa",
  "source_type": "Typ",
  "source_save": "spara",
  "source_cancel": "avbryt",
  "source_saved": "sparad",
  "no_entries": "hittade inga inlägg",
  "more": "fler",
  "login": "Logga in",
  "login_username": "Användarnamn",
  "login_password": "Lösenord",
  "source_last_post": "Senaste artikel visad",
  "filter": "Filter",
  "online_count": "Objekt tillgängliga på servern",
  "offline_count": "Objekt som är tillgängliga lokalt",
  "next": "Nästa",
  "searchremove": "Dölj sök",
  "refreshbutton": "Uppdatera källor",
  "settingsbutton": "Inställningar",
  "logoutbutton": "Logga ut",
  "loginbutton": "Logga in",
  "source_export": "Exportera källor",
  "source_filter": "Filter",
  "source_autotitle_hint": "Lämna tomt för att hämta titel",
  "source_pwd_placeholder": "Inte förändrad",
  "source_refresh": "Uppdatera den här källan",
  "login_invalid_credentials": "Fel användarnamn/lösenord",
  "login_offline": "Offline-lagring",
  "no_title": "Ingen titel",
  "error": "Ett fel uppstod",
  "streamerror": "Inga objekt laddade, ladda om?",
  "reload_list": "Ladda om listan",
  "sources_refreshed": "Källor uppdaterade",
  "app_update": "selfoss har uppdaterats, ladda om igen",
  "app_reload": "Ladda om",
  "error_session_expired": "Sessionen har gått ut",
  "error_add_source": "Kunde inte lägga till källa:",
  "error_delete_source": "Kunde inte ta bort källan:",
  "error_load_tags": "Kunde inte ladda taggar:",
  "error_unknown_tag": "Okänd tagg:",
  "error_unknown_source": "Okänt käll-ID:",
  "error_mark_items": "Kan inte markera alla synliga objekt:",
  "error_mark_item": "Kan inte markera/avmarkera objekt:",
  "error_star_item": "Kan inte stjärna/avstjärna objekt:",
  "error_logout": "Kunde inte logga in:",
  "error_loading": "Laddningsfel:",
  "error_loading_stats": "Kan inte ladda nav-statistik:",
  "error_saving_color": "Det går inte att spara ny färg:",
  "error_refreshing_source": "Kan inte uppdatera källor:",
  "error_sync": "Kunde inte synkronisera senaste ändringarna från servern:",
  "error_offline_storage": "Offline-lagringsfel: {0}. Omladdning kan hjälpa. Inaktiverar offline för tillfället.",
  "error_invalid_subsection": "Ogiltigt underavsnitt:",
  "search_label": "Sökterm",
  "article_actions": "Åtgärder",
  "error_configuration": "Det går inte att ladda konfiguration.",
  "info_url_copied": "URL kopierad till urklipp.",
  "share_native_label": "Dela",
  "share_diaspora_label": "Dela på Diaspora",
  "share_twitter_label": "Dela på Twitter",
  "share_facebook_label": "Dela på Facebook",
  "share_pocket_label": "Spara i Pocket",
  "share_wallabag_label": "Spara i Wallabag",
  "share_wordpress_label": "Dela på WordPress",
  "share_mail_label": "Dela med e-post",
  "share_copy_label": "Kopiera länk till urklipp",
  "error_share_native_abort": "Det går inte att dela objektet - antingen finns det inga delningsmål eller så avbröt du det.",
  "error_share_native": "Det går inte att dela objektet.",
  "close_entry": "Stäng",
  "experimental": "Experimentell",
  "error_unwritable_logs": "Det gick inte att skriva loggar.",
  "error_check_system_logs": "Ett fel uppstod. Kontrollera dina systemloggar.",
  "error_check_log_file": "Ett fel uppstod. Kontrollera loggfilen “{0}”.",
  "source_browse": "Bläddra",
  "tag_change_color_button_title": "Ändra färg",
  "source_warn_cancel_dirty": "Kasta bort osparade ändringar?",
  "offline_navigation_unavailable": "Att byta taggar och källor är för närvarande inte tillgängligt i offlineläge.",
  "sources_leaving_unsaved_prompt": "Lämna inställningar med osparade källändringar?",
  "error_offline_storage_not_available": "Offlinelagring är inte tillgängligt. Se till att din webbläsare {0}stödjer IndexedDB API{1} och, om du använder en Google Chrome baserad webbläsare, att du inte kör selfoss i incognito läge.",
  "error_edit_source": "Kunde inte spara källändringar:",
  "source_menu": "Mer åtgärder",
  "no_sources": "Inga källor konfigurerade.",
  "source_deleting": "Raderar källa…",
  "login_error_generic": "Kunde inte logga in: {errorMessage}",
  "sources_loading": "Laddar källor…",
  "source_params_loading": "Laddar parametrar…",
  "source_saving": "Sparar källändringar…",
  "source_go_to_settings": "Öppna i inställningar",
  "entries_loading": "Läser in poster…",
  "login_in_progress": "Försöker att logga in…",
  "error_unauthorized": "Vänligen {link_begin}logga in{link_end} för att fortsätta.",
  "article_reading_time": "{0}min läs",
  "share_mastodon_label": "Dela på Mastodon"
}
